import styled from 'styled-components';
import Ico36 from 'dc/Ico36';
import Ava36 from 'dc/Ava36';

export const Wrapper = styled.div`
  width: 100%;
  min-height: 48px;
  padding-right: 10px;
  padding-left: 10px;
  display: flex;
  align-items: center;
  background-color: transparent;
`;

export const Icon = styled(Ico36)`
  margin-right: 16px;
  color: ${props => props.color};
`;

export const Avatar = styled(Ava36)`
  margin-right: 16px;
`;
